const BASE = import.meta.env.VITE_API_BASE_URL ?? '';

export interface HireRatingEvent {
  id: string;
  hireeName: string;
  hireeRole: string;
  department: string;
  hireDate: string;
  /** Round landing page message with merge fields already substituted server-side. Present when the event belongs to a round. */
  roundLandingPageMessage?: string | null;
  /** Human-readable cohort period label from the round, e.g. "Q1 2026". */
  roundCohortPeriod?: string | null;
  /** Number of hires in this round assigned to the calling manager. */
  roundHireCount?: number | null;
}

export interface HireRatingAnswerDto {
  questionKey: string;
  value: string;
}

export interface HireRatingSubmission {
  answers: HireRatingAnswerDto[];
}

export async function fetchHireRatingEvent(
  id: string,
  accessToken: string
): Promise<HireRatingEvent> {
  const res = await fetch(`${BASE}/api/hire-ratings/${id}`, {
    headers: { Authorization: `Bearer ${accessToken}` },
  });
  if (res.status === 404) throw new Error('not_found');
  if (res.status === 403) throw new Error('forbidden');
  if (!res.ok) throw new Error('fetch_failed');
  return res.json();
}

export async function submitHireRating(
  id: string,
  submission: HireRatingSubmission,
  accessToken: string
): Promise<void> {
  const res = await fetch(`${BASE}/api/hire-ratings/${id}/submit`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(submission),
  });
  if (!res.ok) throw new Error('submit_failed');
}
